import classNames from 'classnames'
import * as React from 'react'
import { LifeInsuranceOffer } from 'ui/multi-product/constants/models'
import AdvertiserDisclosure from '../../AdvertiserDisclosure'
import { ContactCard } from './ContactCard'
import { FAQs } from './FAQs'
import { OfferCard } from './OfferCard'
import { OfferLoadingIndicator } from './OfferLoadingIndicator'
import { OffersFilter } from './OffersFilter'
import { ViewMoreQuotes } from './ViewMoreQuotes'
const styles = require('./styles')
const contactProfileImage = require('assets/images/Shauna_avatar.jpg')
export interface SimplifiedResultsProps {
  offers: LifeInsuranceOffer[]
  onOfferSelected: (offer: LifeInsuranceOffer) => void
  onCoverageAndTermChange: (policyAmount: number, duration: number) => void
  loadingCustomizedOffer: boolean
  coverageAmount: number
  coverageDuration: number
  dispatchCoverageAmount: (value: number) => void
  dispatchCoverageDuration: (value: number) => void
  onViewMoreOffers: () => void
}

export const SimplifiedResults: React.FC<SimplifiedResultsProps> = ({
  coverageAmount,
  coverageDuration,
  loadingCustomizedOffer,
  offers,
  onCoverageAndTermChange,
  dispatchCoverageAmount,
  dispatchCoverageDuration,
  onOfferSelected,
  onViewMoreOffers,
}: SimplifiedResultsProps) => {
  const recommendedOffers: LifeInsuranceOffer[] = offers
    .filter((o) => o.details.recommended)
    .sort((a: LifeInsuranceOffer, b: LifeInsuranceOffer) => {
      if (a.details.monthlyPremiumAmount < b.details.monthlyPremiumAmount) {
        return -1
      } else if (a.details.monthlyPremiumAmount > b.details.monthlyPremiumAmount) {
        return 1
      }

      return 0
    })

  const noOffersFound = recommendedOffers.length === 0

  const [customFiltersApplied, setCustomFiltersApplied] = React.useState(false)
  const handleApplyFilters = (policyAmount: number, duration: number) => {
    setCustomFiltersApplied(true)
    onCoverageAndTermChange(policyAmount, duration)
  }
  return (
    <div className={styles.container}>
      <AdvertiserDisclosure className={styles.advertiserDisclosure} />
      <div className={styles.mainContentContainer}>
        <div className={styles.headerWrapper}>
          {!noOffersFound && <h3 data-testid="li-results-header">Recommended for you</h3>}
          {noOffersFound && (
            <h3 data-testid="li-results-error">Well this is awkward. Looks like something went wrong on our end.</h3>
          )}
        </div>
        {!noOffersFound && (
          <div className={styles.headerWrapper}>
            <h4 data-testid="li-results-reason">
              You are matched with those quotes because of your health and credit history.
            </h4>
          </div>
        )}

        {!noOffersFound && (
          <div className={styles.hiddenOnDesktop}>
            <OffersFilter
              handleApplyFilters={handleApplyFilters}
              coverageAmount={coverageAmount}
              coverageDuration={coverageDuration}
              onCoverageAmountChange={dispatchCoverageAmount}
              onDurationChange={dispatchCoverageDuration}
              isCollapsible={true}
            />
          </div>
        )}

        <div className={classNames(styles.resultsContainer, { [styles.onlyTwo]: recommendedOffers.length === 2 })}>
          {(loadingCustomizedOffer || noOffersFound) && (
            <OfferLoadingIndicator loading={loadingCustomizedOffer} noOffersFound={noOffersFound} />
          )}
          {!loadingCustomizedOffer &&
            !noOffersFound &&
            recommendedOffers.map((offer, index) => (
              <OfferCard
                offer={offer}
                key={index}
                handleOfferSelected={onOfferSelected}
                customSelection={customFiltersApplied}
              />
            ))}
          {!noOffersFound && (
            <div className={styles.hiddenOnDesktop}>
              <ContactCard
                profileImage={contactProfileImage}
                name={'Shauna'}
                phone={'(844) 755-5327'}
                email={'support@leaplife.com'}
              />
            </div>
          )}

          <FAQs />
          <ViewMoreQuotes onViewMoreOffers={onViewMoreOffers} />
        </div>
      </div>
      {!noOffersFound && (
        <div className={styles.sideBarContainer}>
          <OffersFilter
            handleApplyFilters={handleApplyFilters}
            coverageAmount={coverageAmount}
            coverageDuration={coverageDuration}
            onCoverageAmountChange={dispatchCoverageAmount}
            onDurationChange={dispatchCoverageDuration}
            isCollapsible={false}
          />

          <ContactCard
            profileImage={contactProfileImage}
            name={'Shauna'}
            phone={'(844) 755-5327'}
            email={'support@leaplife.com'}
          />
        </div>
      )}
    </div>
  )
}
